import { render, staticRenderFns } from "./AIEditorTab.vue?vue&type=template&id=5496b8b1&scoped=true"
import script from "./AIEditorTab.vue?vue&type=script&lang=js"
export * from "./AIEditorTab.vue?vue&type=script&lang=js"
import style0 from "./AIEditorTab.vue?vue&type=style&index=0&id=5496b8b1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5496b8b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5496b8b1')) {
      api.createRecord('5496b8b1', component.options)
    } else {
      api.reload('5496b8b1', component.options)
    }
    module.hot.accept("./AIEditorTab.vue?vue&type=template&id=5496b8b1&scoped=true", function () {
      api.rerender('5496b8b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/AIEditorTab.vue"
export default component.exports